import { Link, useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCopy, faLink } from '@fortawesome/free-solid-svg-icons'
import { db } from "../firebase";
import { doc, increment, getDoc, updateDoc, setDoc } from "firebase/firestore";
import QRCode from "react-qr-code";
import { useEffect, useState } from 'react';
import axios from 'axios';
import FadeIn from 'react-fade-in';
import { Typography, Button, message } from 'antd';
import ReactGA from "react-ga4";
import { exchangeAuthCodeForToken } from '../spotifyAuth';
import { setContext, track } from '../analytics';

function QueueCreated() {
  ReactGA.send({ hitType: 'pageview', page: window.location.pathname + window.location.search });
  
  const navigate = useNavigate()
  const initialParams = new URLSearchParams(window.location.search);
  const [queueCode, setQueueCode] = useState(initialParams.get('queueCode') || "");
  const authCode = new URLSearchParams(window.location.search).get('code');
  const stateParam = new URLSearchParams(window.location.search).get('state');

  useEffect(() => {
    document.title = "Queue Created | Auxify";
  });
  
  useEffect(() => {
    const run = async () => {
      try {
        if (authCode && stateParam) {
          const redirectUri = `${window.location.origin}/queue-created`;
          const tokenJson = await exchangeAuthCodeForToken({ code: authCode, redirectUri });
          const hostAccessToken = tokenJson.access_token;
          setQueueCode(stateParam);
          setContext({ queue_code: stateParam, role: 'host' });

          const userURI = await axios.get(`https://api.spotify.com/v1/me`, {
            headers: {
              'Authorization': `Bearer ${hostAccessToken}`,
              'Content-Type': 'application/json'
            }
          }).then(r => r.data.uri);

          await updateDoc(doc(db, "queues", stateParam), {
            host: userURI,
            accessToken: hostAccessToken
          });

          try {
            const docRef = doc(db, "hostURIs", userURI);
            const docSnap = await getDoc(docRef);
            if (docSnap.exists()) {
              await updateDoc(docRef, { numQueuesCreated: increment(1) });
            } else {
              await setDoc(docRef, { numQueuesCreated: 1 });
            }
          } catch (metricsErr) {
            track('host_metrics_update_failed', {});
          }

          track('auth_succeeded', { step: 'queue_created' });
          navigate(`/queue-created?queueCode=${stateParam}`, { replace: true });
        }
      } catch (e) {
        message.error("Spotify authorization failed. Please try again.", 2.5);
        track('token_exchange_failed', { step: 'queue_created' });
      }
    };
    run();
  }, [authCode, navigate, stateParam]);

  return (
    <FadeIn delay={75}>
      <div style={{ maxWidth: "800px", margin: "0 auto", padding: "1em", textAlign: 'center' }}>
        <Typography.Title style={{ fontSize: "3em", textAlign: "left" }}>Queue Created!</Typography.Title>
        <Typography.Title level={3} style={{ color: "green", textAlign: "left" }}>Queue code: {queueCode} &nbsp; <FontAwesomeIcon icon={faCopy} size='xs' onClick={() => {navigator.clipboard.writeText(queueCode); message.info("Copied queue code to clipboard", 2.5)}} style={{color: '#0076d1'}} cursor={'pointer'} /> &nbsp; <FontAwesomeIcon icon={faLink} size='xs' onClick={() => {navigator.clipboard.writeText(`https://auxify.io/view-queue?queueCode=${queueCode}`); message.info("Copied queue URL to clipboard", 2.5)}} style={{color: '#0076d1'}} cursor={'pointer'} /></Typography.Title>
        <Typography.Paragraph style={{ fontSize: "1em", textAlign: "left" }}>Share the queue link, QR code, or queue code with your friends!</Typography.Paragraph>
        <Link to={`/view-queue?queueCode=${queueCode}`} style={{ textAlign: "left" }}><Button type="primary" block>Go to Queue</Button></Link>
        <br />
        <br />
        <QRCode value={`https://auxify.io/view-queue?queueCode=${queueCode}`} />
      </div>
    </FadeIn>
  )
}

export default QueueCreated